import { firebase } from '@/notifications/notifications.config.js';
import { initializeApp } from 'firebase/app';

const firebaseConfig = firebase.configs;
export const publicKey = firebase.publicKey;

const app = initializeApp(firebaseConfig);

export default app;